import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=3228bcef&scoped=true&"
import script from "./cmp.vue?vue&type=script&lang=js&"
export * from "./cmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3228bcef",
  null
  
)

export default component.exports